import * as React from 'react'
function StartupStepFinishIcon(props) {
    return (
        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.25 7.28571L6.10714 11.1429L15.75 1.5" stroke="#7C8E54" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default StartupStepFinishIcon